import crypto from 'crypto-js';
import MobileDetect from 'mobile-detect';
export { default as throttle } from './throttle';
export { default as formatFileSize } from './formatFileSize';
export { default as cartesian } from './cartesian';
export { default as postToken } from './postToken';
export { default as file } from './file';
import envConfig from '@/config';
import { blobToBase64 } from 'cfmoto-utils';
export function randomUUID() {
  const tempUrl = URL.createObjectURL(new Blob());
  const uuid0 = tempUrl.toString();
  URL.revokeObjectURL(tempUrl); // 释放这个url
  return uuid0.substring(uuid0.lastIndexOf('/') + 1);
}

// 加密
export function getAesRes(data) {
  let aseKey = envConfig.env === 'test' ? 'e38c0eb1b52145be80f5f53172d23f0b' : '4fda9c29437afb3c7ba596d41f601b0a';
  var message = JSON.stringify(data);
  // 加密 DES/AES切换只需要修改 CryptoJS.AES <=> CryptoJS.DES
  var encrypt = crypto.AES.encrypt(
    message,
    crypto.enc.Utf8.parse(aseKey), // 参数1=密钥, 参数2=加密内容
    {
      mode: crypto.mode.ECB, // 为DES的工作方式
      padding: crypto.pad.Pkcs7, // 当加密后密文长度达不到指定整数倍(8个字节、16个字节)则填充对应字符
    }
  );
  return crypto.enc.Base64.stringify(encrypt.ciphertext);
}

function blobToImg(blob) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const img = new Image();
      img.addEventListener('load', () => resolve(img));
      img.crossOrigin = 'Anonymous';
      img.src = reader.result;
    });
    reader.readAsDataURL(blob);
  });
}

function imgToCanvas(img, img2) {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const context = canvas.getContext('2d');
  context.drawImage(img, 0, 0);
  if (canvas.width > canvas.height) {
    context.drawImage(img2, 0, 0, canvas.width, canvas.width);
  } else {
    context.drawImage(img2, 0, 0, canvas.height, canvas.height);
  }

  return canvas;
}

// function watermark(canvas) {
//   return new Promise((resolve) => {
//     canvas.toBlob((blob) => resolve(blob));
//   });
// }

// function base64ToFile(dataurl, filename = 'image.png') {
//   if (!dataurl) {
//     return '';
//   }
//   let arr = dataurl.split(','),
//     mime = arr[0].match(/:(.*?);/)[1],
//     bstr = atob(arr[1]),
//     n = bstr.length,
//     u8arr = new Uint8Array(n);
//   while (n--) {
//     u8arr[n] = bstr.charCodeAt(n);
//   }
//   return new File([u8arr], filename, {
//     type: mime,
//   });
// }

// const blobToBase64 = async (blob, fileName) => {
//   const reader = await new FileReader(); // 实例化一个reader文件
//   await reader.readAsDataURL(blob); // 添加二进制文件
//   return new Promise((resolve) => {
//     reader.onload = async (event) => {
//       const base64 = await event.target.result; // 获取到它的base64文件
//       const scale = 0.5; // 设置缩放比例 （0-1）
//       let file = await compressImg(base64, scale, fileName);
//       resolve(file);
//     };
//   });
// };
// // 压缩大小
// const compressImg = (base64, scale, fileName) => {
//   // 处理缩放，转换格式
//   // 用canvas来压缩
//   const img = new Image();
//   img.src = base64;
//   return new Promise((resolve) => {
//     img.onload = async () => {
//       const canvas = document.createElement('canvas');
//       const ctx = canvas.getContext('2d');
//       canvas.setAttribute('width', img.width * scale);
//       canvas.setAttribute('height', img.height * scale);
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
//       // 转成base64 文件
//       base64 = canvas.toDataURL('image/jpeg', 0.8); //0到1之间的取值，主要用来选定图片的质量，默认值是0.92，超出范围也会选择默认值
//       const arr = base64.split(',');
//       const mime = arr[0].match(/:(.*?);/)[1];
//       const bytes = atob(arr[1]);
//       const bytesLength = bytes.length;
//       const u8arr = new Uint8Array(bytesLength);
//       for (let i = 0; i < bytes.length; i++) {
//         u8arr[i] = bytes.charCodeAt(i);
//       }
//       const file = await new File([u8arr], fileName, { type: mime });
//       resolve(file);
//     };
//   });
// };

// 图片加水印
/**
 *
 * @param {File | String} image 图片文件
 * @param {String} text 水印文字
 * @param {String} font 字体属性
 * @param {String} fillStyle 字体颜色
 * @param {Number} rotate 旋转角度
 */
export async function addWaterMark(image, image2) {
  let [img, img2] = await Promise.all([blobToImg(image), blobToImg(image2)]);
  let canvas = imgToCanvas(img, img2);
  let blob = await new Promise((resolve) => canvas.toBlob(resolve));
  let src = await blobToBase64(blob);
  const fileName = new Date().getTime() + '.' + blob.type.split('/')[1] || 'png';
  let newFile = new File([blob], fileName, { type: blob.type });
  let newUrl = window.URL.createObjectURL(newFile);
  return {
    newFile,
    src,
    newUrl,
  };
}
export function getCustomAgent() {
  function isHarmonyNext() {
    const ua1 = (navigator.userAgent.toLowerCase().match(/openharmony/i) && true) || false;
    const ua2 = (navigator.userAgent.toLowerCase().match(/arkweb/i) && true) || false;
    return ua1 || ua2;
  }
  console.log('customAgent请求消息----', window.navigator.customAgent);
  if (!window.navigator.customAgent) {
    // window.navigator.customAgent = 'Mozilla/5.0 (iPhone; CPU iPhone OS 18_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 cfmoto/2.1.3 (iPhone 11 Build/18.1.1)(DeviceNo/xxx)';
    window.navigator.customAgent = window.navigator.userAgent;
  }
  const userAgent = window.navigator.customAgent;
  // const userAgent = window.navigator.userAgent;
  const md = new MobileDetect(userAgent);

  // const appType = this.isAndroid ? 'Android' : 'IOS';
  const appVersion = (/(cfmoto|Cfmoto)\/([\d]+\.[\d]+\.[\d]+)/.exec(userAgent) || [])[2];
  const harmonySystemVersion = ((/OpenHarmony [\\.\d]+/.exec(userAgent) || [])[0] || '').split(' ')[1] || '';
  const systemName = /OpenHarmony/.test(userAgent) ? 'Harmony' : md.os();
  const systemVersionStr = md.versionStr(md.os()) || md.versionStr('Android') || md.versionStr('iOS') || harmonySystemVersion;
  const systemVersion = `${systemName} ${systemVersionStr}`.replace(/_/g, '.').split(' ')[1];
  let phoneModel = (/\(([^\\(]+) (Build\/[\\.\d]+\))/.exec(userAgent) || [])[1] || 'unknown';
  phoneModel = encodeURIComponent(phoneModel);
  const deviceNo = (/\(DeviceNo\/([^)]+)\)/.exec(userAgent) || [])[1] || 'unknown';
  // const phoneModel = ((/(Mobile\/[\w]+)/.exec(userAgent) || [])[1] || 'Build/unknown').replace('Mobile', `Build`);
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const screenSize = `${screenWidth}*${screenHeight}`;
  console.log(md);
  console.log(phoneModel, systemVersion);

  console.log(window.navigator.userAgent); // 'Sony'
  console.log(md.mobile()); // 'Sony'
  console.log(md.phone()); // 'Sony'
  console.log(md.mobileGrade()); // 'Sony'
  console.log(md.tablet()); // null
  console.log(md.userAgent()); // 'Safari'
  console.log(md.os()); // 'AndroidOS'
  console.log(md.is('iPhone')); // false
  console.log(md.is('iPhone')); // false
  console.log(md.version('Webkit')); // 534.3
  console.log(md.versionStr(md.os()) || md.versionStr('Android') || md.versionStr('iOS')); // '4.1.A.0.562'
  console.log(md.match('playstation|xbox')); // false
  console.log('==== appVersion ====');
  console.log((/(cfmoto|Cfmoto)\/([\d]+\.[\d]+\.[\d]+)/.exec(userAgent) || [])[2]);
  console.log('==== model ====');
  console.log((/\(([^\\(]+) (Build\/[\\.\d]+\))/.exec(userAgent) || [])[1] || 'unknown');
  const networkType = !navigator.connection ? 'unknown' : navigator.connection.effectiveType || 'unknown';
  if (/ios/.test((md.os() || '').toLocaleLowerCase())) {
    return `MOBILE|${md.os()}|${systemVersion}|CFMOTO_APP|${appVersion}|iPhone|${phoneModel}|${screenSize}|${deviceNo}|${networkType}|iOS`;
  }
  if (isHarmonyNext()) {
    return `MOBILE|Harmony|${systemVersion}|CFMOTO_APP|${appVersion}|Huawei|${phoneModel}|${screenSize}|${deviceNo}|${networkType}|${md.os()}`;
  }
  // Mozilla/5.0 (iPhone; CPU iPhone OS 18_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 cfmoto/2.1.3 (iPhone 11 Build/18.1.1)
  // return 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.131 Safari/537.36';
  // MOBILE|Android|7.1.1|KLICEN_APP|4.0.10|Dalvik/2.1.0 (Linux; U; Android 7.1.1; OD103 Build/NMF26F)|1080*1920|ccf8ba18defca0f6|100
  return `MOBILE|Android|${systemVersion}|CFMOTO_APP|${appVersion}|${phoneModel}|${screenSize}|${deviceNo}|${networkType}|${md.os()}`;
}

export default {};
